import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_GREY_6 } from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_GREY_6)};
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
`;
